import React, { useEffect, useState } from "react";
import {
  addBlog,
  deleteBlogById,
  getAllBlogs,
} from "../../services/blogService";
import { Link } from "react-router-dom";
import DialogBox from "../../components/ui/DialogBox";

const Blogs = () => {
  // List all blogs
  const [blogs, setBlogs] = useState([]);
  const [blogsLoading, setBlogsLoading] = useState(false);

  const fetchAllBlogsAsync = async () => {
    setBlogsLoading(true);
    const res = await getAllBlogs();
    setBlogs(res?.data);
    setBlogsLoading(false);
  };

  useEffect(() => {
    fetchAllBlogsAsync();
  }, []);

  // adding new blog
  const [showAddBlogDialog, setShowAddBlogDialog] = useState(false);
  const openAddBlogDialog = () => {
    setShowAddBlogDialog(true);
  };
  const closeAddBlogDialog = () => {
    setShowAddBlogDialog(false);
    setNewBlogName("");
  };

  const [newBlogName, setNewBlogName] = useState("");
  const [addBlogLoading, setAddBlogLoading] = useState(false);

  const handleAddBlogClick = async () => {
    setAddBlogLoading(true);
    const blog_text = "Sample blog text.";
    await addBlog(newBlogName, blog_text);
    await fetchAllBlogsAsync();
    closeAddBlogDialog();
    setAddBlogLoading(false);
  };

  // adding new blog
  const [showDeleteBlogDialog, setShowDeleteBlogDialog] = useState(false);
  const [currentBlogToDelete, setCurrentBlogToDelete] = useState(null);

  const openDeleteBlogDialog = (selected_blog) => {
    setCurrentBlogToDelete(selected_blog);
    setShowDeleteBlogDialog(true);
  };
  const closeDeleteBlogDialog = () => {
    setShowDeleteBlogDialog(false);
  };

  const handleDeleteBlogClick = async () => {
    await deleteBlogById(currentBlogToDelete?.id);
    await fetchAllBlogsAsync();
    closeDeleteBlogDialog();
  };

  return (
    <>
      {showAddBlogDialog && (
        <DialogBox
          closeDialog={closeAddBlogDialog}
          action={handleAddBlogClick}
          actionText="Add"
          // closeOnOutsideClick={true}
          actionDisabled={addBlogLoading}>
          <div className="flex flex-col pb-4 gap-1">
            <div className="text-slate-700">Blog Name</div>
            <input
              type="text"
              className="rounded"
              value={newBlogName}
              onChange={(e) => {
                setNewBlogName(e.target.value);
              }}
            />
          </div>
        </DialogBox>
      )}
      {showDeleteBlogDialog && (
        <DialogBox
          closeDialog={closeDeleteBlogDialog}
          action={handleDeleteBlogClick}
          actionText="Delete">
          <div className="px-8 py-2">
            Are you sure you want to delete the blog?
          </div>
        </DialogBox>
      )}
      <div className="px-20 py-10 min-h-screen">
        <div className="flex flex-col gap-4">
          <div className="flex items-center">
            <div className="text-xl font-semibold">Blogs</div>
            <button
              onClick={openAddBlogDialog}
              className="ml-auto bg-black text-white px-4 py-2 rounded">
              Add Blog
            </button>
          </div>
          {blogsLoading ? (
            <div>Loading...</div>
          ) : blogs.length === 0 ? (
            <div className="flex justify-center items-center min-h-[50vh]">
              No blogs added
            </div>
          ) : (
            <div>
              <table className="w-full table-auto rounded">
                <thead>
                  <tr>
                    <th className="px-4 py-2">Name</th>
                    <th className="px-4 py-2"></th>
                  </tr>
                </thead>
                <tbody>
                  {blogs.map((item) => (
                    <tr key={item.id}>
                      <td className="border w-1/2 ">
                        <Link className="w-full" to={`blog/${item.id}`}>
                          <div className="w-full px-4 py-2 hover:text-blue-600">
                            {item.name}
                          </div>
                        </Link>
                      </td>
                      <td className="border">
                        <div className="w-full px-4 py-2 flex gap-2">
                          <Link className="" to={`edit_blog/${item.id}`}>
                            <button className="bg-slate-200 px-2 py-1 rounded hover:bg-slate-300">
                              Edit
                            </button>
                          </Link>

                          <button
                            onClick={() => {
                              openDeleteBlogDialog(item);
                            }}
                            className="bg-slate-200 px-2 py-1 rounded hover:bg-slate-300">
                            Delete
                          </button>
                        </div>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          )}
        </div>
      </div>
    </>
  );
};

export default Blogs;
